import { createSelector } from '@ngrx/store';

import { getJobPostUrlState, jobPostUrlAdapter } from '@shared/invite-to-apply/store/invite-to-apply.reducer';

export const {
  selectEntities: getJobPostUrlEntities,
} = jobPostUrlAdapter.getSelectors(getJobPostUrlState);

export const getJobPostUrlSelector = createSelector(
  getJobPostUrlEntities,
  (entities, { jobId }) => entities?.[jobId]?.url
);

export const getJobPostUrlErrorSelector = createSelector(
  getJobPostUrlEntities,
  (entities, { jobId }) => entities?.[jobId]?.error
);

